import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomainStatus, DomainStatusLabels} from '../../domain/domain-status.enum';

@Component({
  selector: 'cm-domain-status-box',
  template: `
    <span class="status-plate" matBadge="✔" [matBadgeHidden]="!activeBox"
          (click)="onClick()"
          [ngClass]="{
        'status-plate--green': status === DomainStatus.APPROVED,
        'status-plate--blue': status === DomainStatus.READY,
        'status-plate--orange': status === DomainStatus.PENDING,
        'status-plate-active': activeBox ,
        'status-plate--red': status === DomainStatus.REJECTED || status===DomainStatus.INACTIVE,
        'status-plate--gray': status === DomainStatus.ARCHIVED}">
				<small>{{DomainStatusLabels[status]}}</small>
        <ng-content></ng-content>
      </span>
  `
})
export class DomainStatusBoxComponent {

  @Input()
  public status: DomainStatus;

  @Input()
  public activeBox = false;

  @Output()
  statusClicked = new EventEmitter<DomainStatus>();

  public DomainStatus = DomainStatus;
  public DomainStatusLabels = DomainStatusLabels;

  onClick() {
    this.statusClicked.emit(this.status);
  }
}
